module.exports = __webpack_public_path__ + "static/media/cstb.9205f977.png";